import { formatDate } from "@/lib/dayjs/format-date";
import type { BillingStatus } from "@/lib/gql/__generated__/graphql";

import { SettingsBillingSection } from "../../../_shared/section";

type Props = {
	billingStatus: BillingStatus;
};

export const BasicTicketCurrentStatusSection = ({ billingStatus }: Props) => {
	return (
		<SettingsBillingSection title="現在のステータス">
			<p className="col-span-2 line-clamp-4">{billingStatus.currentBasicBillingTicketName || "未選択"}</p>
			{billingStatus.validDtEndBasic && (
				<div className="col-span-1">
					<p className="text-xs">有効期限</p>
					<p>{formatDate(billingStatus.validDtEndBasic, "YYYY年MM月DD日")}まで</p>
				</div>
			)}
		</SettingsBillingSection>
	);
};

BasicTicketCurrentStatusSection.displayName = "BasicTicketCurrentStatusSection";
